
import CloudDrizzle from "../../../assets/duotone/CloudDrizzle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CloudDrizzleIcon({ className, dataTestid = "CloudDrizzleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CloudDrizzle data-testid={dataTestid} className={classes} {...rest} />
  );
}
